/** This enumeration defines the wish list visibility types */
export enum WishlistVisibilityEnum {
    Public = 'PUBLIC',
    Private = 'PRIVATE'
}
